import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api";

export const initialState = {
  miscRates: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1
};

export const miscRatesSlice = createSlice({
  name: 'miscRates',
  initialState,
  reducers: {
    setMiscRates: (state, { payload }) => {
      state.miscRates = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    updateMiscRateStatus: (state, { payload }) => {
      const { id, status } = payload;
      const rate = state.miscRates.find((r) => r.id === id);
      if (rate) {
        rate.status = status;
      }
    }
  }
});

// Change misc rate status
export const changeMiscRateStatus = (id, data) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.statusChange(id, data, 'misc-rate');
    if (json.status >= 200 && json.status < 300) {
      dispatch(updateMiscRateStatus({ id, status: data.status }));
    } else {
      dispatch(setError(json.data));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

// --------------------------
// Thunks
// --------------------------

// Fetch all misc rates
export const fetchMiscRates = (page, params, disableLoader, Async) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchMiscRates(page, params);
    if (result.status >= 200 && result.status < 300) {
      if (Async) {
        return result?.data?.data;
      } else {
        dispatch(setMiscRates(result.data));
      }
    } else if (result?.status === 422) {
      if (Async) {
        return [];
      } else {
        dispatch(setError(result.data));
      }
    }
  } catch (error) {
    console.log("error", error);
  }
  !disableLoader && dispatch(setLoader(false));
};

// Add misc rate
export const addMiscRate = (data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addMiscRate(data); // ensure this API method exists
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};

// Update misc rate
export const updateMiscRate = (data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.updateMiscRate(data, itemId); // ensure this API method exists
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};


// Remove multiple misc rates
export const removeMultipleMiscRates = (payload, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const res = await Api.removeMultipleMiscRates(payload);
    if (res?.data?.success) {
      callback(true, res?.data?.message);
      dispatch(fetchMiscRates());
    } else {
      callback(false, res?.data?.message || "Failed to delete");
    }
  } catch (err) {
    callback(false, "Something went wrong");
  } finally {
    dispatch(setLoader(false));
  }
};

// --------------------------
// Exports
// --------------------------
export const { setMiscRates, setLoader, setError, updateMiscRateStatus } = miscRatesSlice.actions;

export default miscRatesSlice.reducer;

// Selector
export const miscRatesSelector = (state) => state.miscRates;
